import { Injectable } from '@angular/core'
import { BehaviorSubject } from 'rxjs'

export interface LoginIntroState {
  /** Bumped per play so the overlay re-mounts and its CSS animations restart. */
  run: number
  /** Total length in seconds (the prototype's 2.8s "Turbine" intro). */
  T: number
  /** Where the black overlay wipes in from, as CSS percentages ("78% 72%"): the Sign In button. */
  origin: string
}

const DURATION_S = 2.8

/**
 * The sign-in "Turbine" intro from the RotoTrack prototype. `play()` mounts the overlay (rt-login-intro in
 * app.component.html) and resolves 0.6 s before it ends, so the caller navigates to the schedule while the
 * screen is still covered and the overlay fades out over the signed-in app. Skipped under reduced motion.
 */
@Injectable({ providedIn: 'root' })
export class LoginIntroService {
  readonly state$ = new BehaviorSubject<LoginIntroState | null>(null)
  private run = 0

  play(from?: Element | null): Promise<void> {
    if (typeof matchMedia === 'function' && matchMedia('(prefers-reduced-motion: reduce)').matches) return Promise.resolve()
    const T = DURATION_S
    this.state$.next({ run: ++this.run, T, origin: originOf(from) })
    const run = this.run
    setTimeout(() => { if (this.run === run) this.state$.next(null) }, (T + 0.3) * 1000)
    return new Promise(resolve => setTimeout(resolve, (T - 0.6) * 1000))
  }
}

function originOf(el?: Element | null): string {
  if (!el || typeof innerWidth !== 'number') return '78% 72%'
  const r = el.getBoundingClientRect()
  const x = ((r.left + r.width / 2) / innerWidth) * 100
  const y = ((r.top + r.height / 2) / innerHeight) * 100
  return `${x.toFixed(1)}% ${y.toFixed(1)}%`
}
